export default __webpack_public_path__ + "static/media/JP.95afd85a.svg";